import { render, staticRenderFns } from "./ProgramModuleSelectbox.vue?vue&type=template&id=48c78495&"
import script from "./ProgramModuleSelectbox.vue?vue&type=script&lang=js&"
export * from "./ProgramModuleSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports